var _circle, _circle2, _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndOrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0039,
    cy: 10,
    r: 9.5,
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0039,
    cy: 10,
    r: 9.5,
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_207_6434",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0039 18.0015C18.4328 16.177 20.0039 13.2724 20.0039 10.0007C20.0039 6.7291 18.4328 3.82441 16.0039 2C13.575 3.82441 12.0039 6.7291 12.0039 10.0007C12.0039 13.2724 13.575 16.177 16.0039 18.0015Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0039 18.0015C18.4328 16.177 20.0039 13.2724 20.0039 10.0007C20.0039 6.7291 18.4328 3.82441 16.0039 2C13.575 3.82441 12.0039 6.7291 12.0039 10.0007C12.0039 13.2724 13.575 16.177 16.0039 18.0015Z",
    fill: "#FF7FBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0039 18.0015L15.4033 18.801L16.0039 19.2521L16.6045 18.801L16.0039 18.0015ZM16.0039 2L16.6045 1.20043L16.0039 0.749322L15.4033 1.20043L16.0039 2ZM19.0039 10.0007C19.0039 12.9446 17.5916 15.5582 15.4033 17.2019L16.6045 18.801C19.274 16.7959 21.0039 13.6002 21.0039 10.0007H19.0039ZM15.4033 2.79957C17.5916 4.44323 19.0039 7.05691 19.0039 10.0007H21.0039C21.0039 6.40129 19.274 3.20559 16.6045 1.20043L15.4033 2.79957ZM13.0039 10.0007C13.0039 7.05691 14.4162 4.44323 16.6045 2.79957L15.4033 1.20043C12.7338 3.20559 11.0039 6.40129 11.0039 10.0007H13.0039ZM16.6045 17.2019C14.4162 15.5582 13.0039 12.9446 13.0039 10.0007H11.0039C11.0039 13.6002 12.7338 16.7959 15.4033 18.801L16.6045 17.2019Z",
    fill: "black",
    mask: "url(#path-3-inside-1_207_6434)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndOrIcon);
export default __webpack_public_path__ + "static/media/and-or-icon.4a0cf9afa06ccbeda57442afbcea6bcd.svg";
export { ForwardRef as ReactComponent };